import { render } from "./Cards.vue?vue&type=template&id=3b469e7e&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=3b469e7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b469e7e"

export default script